/* DON'T EDIT THIS FILE: edit original and run build again */ /**
 * Generate an array of numbers from start to end with a step.
 *   Start is included but end is not included.
 */
export const range = (start: number, end: number, step: number = 1) => {
  const length = Math.floor((end - start) / step);
  return Array.from({ length }, (_, i) => start + i * step);
};
